import { axiosV1 } from 'interceptors/axios';
import { store } from 'redux/store';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export const getCKEditorToken = async () => {
  try {
    const { data } = await axiosV1.get('/ckeditor/token');
    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    dispatchError(error, store.dispatch);
    throw error;
  }
};
